<template>
  <div>
    <base-spinner v-if="loading" />
    <div v-else class="driver-table-container col-12">
      <div class="row align-items-center">
        <!-- <div class="col-4">
          <h5 id="drivers_length" class="result">
            {{ rows }} {{ $t("results") }}
          </h5>
        </div> -->
        <div class="col-4 ms-auto">
          <div class="filter-drivers">
            <b-sidebar
              id="sidebar-backdrop"
              :backdrop-variant="variant"
              bg-variant="white"
              backdrop
              :right="!isLangRtl"
              shadow
              @hidden="$emit('resetSearch')"
            >
              <div class="px-3 py-2">
                <h4 class="filter-drivers__head">{{ $t("filter-by") }}</h4>
                <h5 class="filter-input-title">{{ $t("supplier") }}</h5>
                <hr />
                <b-form-group class="mb-3" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    v-model="searchPayload.selected_radio_provider"
                    :options="radioOptions"
                    :aria-describedby="ariaDescribedby"
                    name="plain-inline"
                    id="driver_filter_options"
                    class="d-flex"
                  ></b-form-radio-group>
                </b-form-group>
                <base-select
                  class="mb-3"
                  :options="other_suppliers"
                  id="driver_filter_provider"
                  label="source"
                  :small="true"
                  :disabled="searchPayload.selected_radio_provider !== null"
                  field="provider"
                  :value="searchPayload.provider"
                  @change-value="changeSupplier"
                >
                </base-select>
                <h5 class="filter-input-title">{{ $t("driver") }}</h5>
                <hr />

                <div>
                  <div class="row">
                    <div class="col-12 mb-3">
                      <div class="form-label label-text">
                        {{ $t("report-as-per") }}
                      </div>
                      <div class="input-group">
                        <b-modal
                          :id="modalReportId"
                          ref="modalReportId"
                          centered
                          hide-header
                          hide-footer
                          no-fade
                          static
                          content-class="w-auto mx-auto"
                        >
                          <b-calendar
                            v-model="searchPayload.availability_date"
                            @context="(ctx) => (dateReportContext = ctx)"
                            @input="$refs.modalReportId.hide()"
                          >
                          </b-calendar>
                        </b-modal>
                        <b-input-group v-b-modal="modalReportId">
                          <label
                            class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                          >
                            <span
                              v-if="!dateReportContext.selectedYMD"
                              class="time-placeHolder"
                              >{{ $t("select-date") }}</span
                            >
                            {{ dateReportContext.selectedYMD }}
                            <img
                              :src="
                                require(`@/assets/images/icons/select-time.svg`)
                              "
                              alt="select time"
                            />
                          </label>
                        </b-input-group>
                      </div>
                    </div>
                  </div>
                </div>
                <base-multi-select
                  class="mb-3"
                  :options="StatusOptions"
                  label="status"
                  placeholder="search"
                  id="driver_filter_status"
                  field="status"
                  :value="searchPayload.status"
                  :small="true"
                  @change-value="setValue"
                />
                <base-multi-select
                  class="mb-3"
                  :options="$store.getters['enums/garage_enums']"
                  label="garage"
                  placeholder="search"
                  id="vehicles-operations-filter-garage-input"
                  field="garage"
                  :value="searchPayload.garage"
                  :small="true"
                  @change-value="setValue"
                />
                <base-select
                  id="check-availability-form-religion"
                  name="religion"
                  label="religion"
                  :options="$store.getters['enums/religion_enums']"
                  field="religion"
                  :small="true"
                  :value="searchPayload.religion"
                  @change-value="setValue"
                ></base-select>
                <base-select
                  id="driver-form-step-1-designation-type"
                  name="designation-type"
                  label="designation-type"
                  :options="designationTypeOptions"
                  field="designationType"
                  :small="true"
                  :value="searchPayload.designationType"
                  @change-value="setValue"
                  :useI18n="true"
                />
                <base-select
                  id="driver-form-step-1-service-type"
                  name="serviceType"
                  label="service-type"
                  :options="serviceTypeOptions"
                  field="serviceType"
                  :small="true"
                  :value="searchPayload.serviceType"
                  @change-value="setValue"
                  :useI18n="true"
                />
                <base-select
                  id="add-vehicle-step-2-tga-card-status"
                  name="tga card status"
                  label="tga-card-status"
                  placeholder="tga-card-status"
                  field="tgaCardStatus"
                  :options="tgaCardStatusOptions"
                  :small="true"
                  :value="searchPayload.tgaCardStatus"
                  @change-value="setValue"
                  :useI18n="true"
                />
                <base-input
                  type="text"
                  label="english-name"
                  id="driver_filter_Name"
                  name="Name"
                  placeholder="english-name"
                  field="name"
                  :small="true"
                  :value="searchPayload.name"
                  @change-value="setValue"
                ></base-input>
                <base-input
                  type="text"
                  label="name-in-arabic"
                  placeholder="name-in-arabic"
                  id="driver_filter_arabicName"
                  :small="true"
                  field="arabicName"
                  :value="searchPayload.arabicName"
                  @change-value="setValue"
                  name="Arabic Name"
                >
                </base-input>
                <base-select
                  class="mb-3"
                  :options="GenderOptions"
                  label="gender"
                  :small="true"
                  id="driver_filter_gender"
                  field="gender"
                  :value="searchPayload.gender"
                  @change-value="setValue"
                  :useI18n="true"
                >
                </base-select>
                <base-input
                  type="number"
                  label="phone-number"
                  placeholder="966512345678"
                  name="phone-number"
                  id="driver_filter_mobileNumber"
                  field="mobileNumber"
                  :value="searchPayload.mobileNumber"
                  @change-value="setValue"
                  :small="true"
                >
                </base-input>

                <base-select
                  class="mb-3"
                  :options="$store.getters['enums/nationality_enums']"
                  label="nationality"
                  :small="true"
                  id="driver_filter_nationality"
                  field="nationality"
                  :value="searchPayload.nationality"
                  @change-value="setValue"
                >
                </base-select>

                <base-input
                  type="number"
                  label="employee-id"
                  name="Employee ID"
                  placeholder="employee-id"
                  id="driver_filter_employee_id"
                  field="employee_id"
                  :value="searchPayload.employee_id"
                  @change-value="setValue"
                  :small="true"
                >
                </base-input>

                <base-input
                  type="number"
                  label="iqama-number-entry"
                  name="Id Number"
                  placeholder="iqama-number-entry"
                  id="driver_filter_id_number"
                  field="idNumber"
                  :value="searchPayload.idNumber"
                  @change-value="setValue"
                  :small="true"
                >
                </base-input>
                <h5 class="filter-input-title">{{ $t("license") }}</h5>
                <hr />
                <base-multi-select
                  class="mb-3"
                  :options="$store.getters['enums/license_type_enums']"
                  label="license-type"
                  placeholder="search"
                  id="driver_filter_licenseType"
                  field="licenseType"
                  :value="searchPayload.licenseType"
                  :small="true"
                  @change-value="setValue"
                >
                </base-multi-select>
                <div>
                  <label
                    class="datepicker-placeholder"
                    for="datepicker-placeholder"
                  >
                    {{ $t("license-expiry-date") }}
                  </label>

                  <div class="row">
                    <div class="col-6 mt-2">
                      <div class="form-label label-text">
                        {{ $t("from") }}
                      </div>
                      <div class="input-group">
                        <b-modal
                          :id="modalFromId"
                          ref="modalFromId"
                          centered
                          hide-header
                          hide-footer
                          no-fade
                          static
                          content-class="w-auto mx-auto"
                        >
                          <b-calendar
                            v-model="searchPayload.licenseExpiry"
                            @context="(ctx) => (dateFromContext = ctx)"
                            @input="$refs.modalFromId.hide()"
                          >
                          </b-calendar>
                        </b-modal>
                        <b-input-group v-b-modal="modalFromId">
                          <label
                            class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                          >
                            <span
                              v-if="!dateFromContext.selectedYMD"
                              class="time-placeHolder"
                              >{{ $t("select-date") }}</span
                            >
                            {{ dateFromContext.selectedYMD }}
                            <img
                              :src="
                                require(`@/assets/images/icons/select-time.svg`)
                              "
                              alt="select time"
                            />
                          </label>
                        </b-input-group>
                      </div>
                    </div>
                    <div class="col-6 mt-2">
                      <div class="form-label label-text">
                        {{ $t("to") }}
                      </div>
                      <div class="input-group">
                        <b-modal
                          :id="modalToId"
                          ref="modalToId"
                          centered
                          hide-header
                          hide-footer
                          no-fade
                          static
                          content-class="w-auto mx-auto"
                        >
                          <b-calendar
                            v-model="searchPayload.driver_license_end_date"
                            @context="(ctx) => (dateToContext = ctx)"
                            @input="$refs.modalToId.hide()"
                          >
                          </b-calendar>
                        </b-modal>
                        <b-input-group v-b-modal="modalToId">
                          <label
                            class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                          >
                            <span
                              v-if="!dateToContext.selectedYMD"
                              class="time-placeHolder"
                              >{{ $t("select-date") }}</span
                            >
                            {{ dateToContext.selectedYMD }}
                            <img
                              :src="
                                require(`@/assets/images/icons/select-time.svg`)
                              "
                              alt="select time"
                            />
                          </label>
                        </b-input-group>
                      </div>
                    </div>
                  </div>
                </div>
                <base-button
                  class="search-btn primary mt-4 mb-3"
                  @click="filterBySideBar"
                  id="drivers-filter-submit-btn"
                >
                {{ showDownloadFilters ? $t("export") : $t("search") }}
              </base-button>
                <base-button
                  id="drivers-filter-reset-btn"
                  class="reset-btn mb-1"
                  @click="resetSearchPayload"
                >
                {{ showDownloadFilters ? $t("cancel") : $t("reset-filters") }}
              </base-button>
              </div>
            </b-sidebar>
          </div>
        </div>
      </div>
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div
            class="d-flex flex-column my-1"
            v-for="(error_text, index) in error"
            :key="index"
          >
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div class="mt-4" v-if="selected_view === 'table'">
        <div v-if="!group_by_key || group_by_key === 'none'">
          <CommonTable
            :items="items"
            :fields="fields"
            :currentPage="currentPage"
            @filterBySideBar="filterBySideBar"
          />
        </div>
        <div v-else>
          <CommonTable
            :items="[]"
            :fields="fields"
            :currentPage="currentPage"
            tbodyClass="d-none"
            @changeParentSorting="changeParentSorting"
            @filterBySideBar="filterBySideBar"
          />
          <div v-for="(each, index) in Object.keys(group_by_data)" :key="index">
            <div
              class="mb-3 group-by-block cursor-pointer"
              v-b-toggle="`collapse-group-${index}`"
            >
              <div>
                <span class="label">{{ each }}</span>
                <span class="count"> ({{ group_by_data[each].length }}) </span>
              </div>
              <img
                :src="require(`@/assets/images/icons/accordian-icon.svg`)"
                alt="accordian-icon"
              />
            </div>
            <b-collapse :id="`collapse-group-${index}`">
              <CommonTable
                :items="group_by_data[each]"
                :fields="fields"
                :sortByProp="sortByProp"
                :sortDescProp="sortDescProp"
                :currentPage="currentPage"
                theadClass="d-none"
                @filterBySideBar="filterBySideBar"
              />
            </b-collapse>
          </div>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
          last-number
          aria-controls="my-table"
          class="d-flex justify-content-end"
        ></b-pagination>
      </div>
      <div class="row mt-4" v-if="selected_view === 'grid'">
        <div
          class="col-lg-4 col-md-6 col-xs-12 mb-3"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="grid-block cursor-pointer" @click="routeToDetails(item)">
            <div class="topbar">
              <div>
                <div class="name mb-1">
                  {{ item?.name }}
                </div>
                <div class="name">
                  {{ item?.arabicName }}
                </div>
              </div>
              <div class="d-flex align-items-center">
                <img
                  class="me-2"
                  :src="require('@/assets/images/icons/phone-call.svg')"
                  alt="phone-call"
                />
                <div>
                  {{ item?.phoneNumber }}
                </div>
              </div>
              <div class="d-flex align-items-center">
                <img
                  class="me-2"
                  :src="require('@/assets/images/icons/map.svg')"
                  alt="map"
                />
                <div>
                  {{
                    isLangRtl
                      ? item?.city?.arabicName
                      : item?.city?.name || "----"
                  }}
                </div>
              </div>
            </div>
            <div class="content">
              <div class="row mb-3">
                <div class="col" v-if="item?.paymentMethod">
                  <div class="field mb-1">{{ $t("payment-method") }}</div>
                  <div class="value">{{ item?.paymentMethod }}</div>
                </div>
                <div class="col" v-if="item?.clientGrade?._id">
                  <div class="field mb-1">{{ $t("clients-grade") }}</div>
                  <div class="value d-flex align-items-center">
                    <div class="me-2">
                      {{
                        isLangRtl
                          ? item?.clientGrade?.arabicName
                          : item?.clientGrade?.name || "----"
                      }}
                    </div>
                    <img
                      :src="require('@/assets/images/icons/star.svg')"
                      alt="star"
                    />
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-if="
                  item?.contactPersonName ||
                  item?.contactPersonEmail ||
                  item?.contactPersonPhone
                "
              >
                <div class="col">
                  <div class="field mb-1">
                    {{ $t("contact-person-details") }}
                  </div>
                  <div class="value row">
                    <div class="col-6">{{ item?.contactPersonName }}</div>
                    <div class="col-6">{{ item?.contactPersonEmail }}</div>
                    <div class="col-12 mt-2">
                      {{ item?.contactPersonPhone }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
          last-number
          aria-controls="my-table"
          class="d-flex justify-content-end"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DriverService from "@/services/driver.service";
import CommonTable from "./CommonTable.vue";
import moment from "moment";
export default {
  components: {
    CommonTable,
  },
  emits: ["getAvailableLengths", "resetQuickSearchPayload"],
  props: ["searchParamsFromParent", "fields", "selected_view","showDownloadFilters","resetSearch"],

  data() {
    return {
      sortBtnHovered: false,
      error: null,
      loading: false,
      EditHovered: false,
      DeleteHovered: false,
      sortDesc: false,
      perPage: 40,
      currentPage: 1,
      modes: ["single", "range"],
      items: [],
      itemsCopy: [],
      sortBy: "",
      sortOrders: {},
      selectMode: "single",
      cancelBtnStyle:
        "display:inline-block;width:92px;background-color:transparent;color:var(--color-09);border:2px solid var(--color-09);font-weight:600",
      deleteBtnStyle:
        "display:inline;width:92px;border:2px solid var(--color-23);",
      variant: "transparent",
      radioOptions: [{ text: "", value: "" }],
      other_suppliers: [],
      GenderOptions: [
        { value: null, text: "please-select-option" },
        {
          value: "male",
          text: "male",
        },
        {
          value: "female",
          text: "female",
        },
      ],
      StatusOptions: [
        { text: this.$t("not-ready"), value: "false" },
        {
          value: "true",
          text: this.$t("ready"),
        },

        {
          value: "leaver",
          text: this.$t("leaver"),
        },
        {
          value: "stopped",
          text: this.$t("stopped"),
        },

        {
          value: "lease",
          text: this.$t("lease"),
        },
        {
          value: "acting-ops",
          text: this.$t("acting-ops"),
        },
      ],
      designationTypeOptions: [
        { value: null, text: "please-select-option" },
        {
          value: "Permanent",
          text: "permanent",
        },
        {
          value: "Temporary",
          text: "temporary",
        },
        {
          value: "Seasonal",
          text: "seasonal",
        },
      ],
      serviceTypeOptions: [
        { value: null, text: "please-select-option" },
        {
          value: "Charter",
          text: "charter",
        },
        {
          value: "Contract",
          text: "contract",
        },
      ],
      tgaCardStatusOptions: [
        { value: null, text: "please-select-option" },
        {
          value: "Valid",
          text: "valid",
        },
        {
          value: "Expired",
          text: "Expired",
        },
        {
          value: "Not_Exists",
          text: "not-exists",
        },
      ],
      driver_license_end_date: null,
      licenseExpiry: null,
      modalReportId: "date-picker-report",
      modalFromId: "date-picker-modal1",
      modalToId: "date-picker-modal2",
      dateReportContext: {},
      dateFromContext: {},
      dateToContext: {},
      selected_supplier: null,
      selected_gender: null,
      selected_nationality: null,
      selected: "saptco",
      searchPayload: {
        provider: null,
        gender: "",
        status: [],
        nationality: null,
        licenseType: [],
        driver_license_end_date: null,
        licenseExpiry: null,
        employee_id: "",
        name: "",
        arabicName: "",
        mobileNumber: "",
        selected_radio_provider: "",
        availability_date: null,
        garage: [],
        religion: null,
        designationType: null,
        serviceType: null,
        tgaCardStatus: null,
      },
      selectedNationality: null,
      rows: 0,
      availableLengths: 0,
      unAvailableLengths: 0,
      group_by_key: null,
      sortByProp: "",
      sortDescProp: false,
      quick_search_key: null,
      quick_search_value: null,
      group_by_data: null,
    };
  },

  watch: {
    currentPage(newPage) {
      this.filterBySideBar();
    },
    selectedNationality(newValue) {
      this.searchPayload.nationality = newValue.code;
    },
    items: {
      handler() {
        this.itemsCopy = [...this.items];
        if (this.group_by_key) this.groupByKey(this.group_by_key);
      },
      immediate: true,
    },
    showDownloadFilters(val) {
      if (val) this.$root.$emit("bv::toggle::collapse", "sidebar-backdrop");
    },
    providerEnums: {
      immediate: true,
      handler(enums) {
        if (enums && enums.length > 0) {
          let radio_items = [{ text: this.$t("other"), value: null }];
          for (let i = 0; i < enums.length; i++) {
            if (enums[i].text == this.$t("saptco")) {
              radio_items.push(enums[i]);
            }
          }
          this.radioOptions = radio_items;

          let temp = [];
          for (let i = 0; i < enums.length; i++) {
            if (enums[i].text != this.$t("saptco")) {
              temp.push(enums[i]);
            }
          }
          this.other_suppliers = temp;
        }
      },
    },
    // "searchPayload.availability_date": {
    //   deep: "true",
    //   handler(val) {
    //     if (val) this.driversAvailability();
    //   },
    // },
  },
  computed: {
    providerEnums() {
      return this.$store.getters["enums/provider_enums"];
    },
  },
  methods: {
    AssignDriverToDriver() {
      this.$router.push("/driver/assign-driver").catch(() => {});
    },
    closeModel(id) {
      this.$bvModal.hide(`delete-driver-modal-${id}`);
    },
    setValue(val, field) {
      this.searchPayload[field] = val;
    },
    changeSupplier(supplier) {
      if (!this.searchPayload.selected_radio_provider)
        this.searchPayload.provider = supplier;
    },
    async filterBySideBar() {
      this.loading = true;
      let params = new URLSearchParams();

      if (this.quick_search_key && this.quick_search_value)
        params.append(
          this.quick_search_key,
          "*" + this.quick_search_value + "*"
        );

      const branchID = !this.$store.getters["enums/user_info"].branch
        ? "all"
        : this.$store.getters["enums/user_info"].branch;
      params.append("branchID", branchID);
      params.append("page", this.currentPage);
      params.append("limit", this.perPage);
      params.append("sort", "-updated_on");
      if (this.searchPayload.gender)
        params.append("gender", this.searchPayload.gender);
      if (this.searchPayload.status && this.searchPayload.status.length) {
        const activeStatuses = this.searchPayload.status.filter(
          (item) => item.value === "true" || item.value === "false"
        );
        const nonActiveStatuses = this.searchPayload.status.filter(
          (item) => item.value !== "true" && item.value !== "false"
        );
        if (activeStatuses?.length) {
          params.append(
            "active",
            "in:[" + activeStatuses?.map((each) => each.value) + "]"
          );
        }
        if (nonActiveStatuses?.length) {
          params.append(
            "nonAvailableStatus",
            "in:[" + nonActiveStatuses?.map((each) => each.value) + "]"
          );
        }
      }
      if (this.searchPayload.garage.length) {
        params.append(
          "garage",
          "in:[" + this.searchPayload.garage.map((each) => each.value) + "]"
        );
      }
      if (this.searchPayload.religion)
        params.append("religion", this.searchPayload.religion);
      if (this.searchPayload.designationType)
        params.append("designationType", this.searchPayload.designationType);
      if (this.searchPayload.serviceType)
        params.append("serviceType", this.searchPayload.serviceType);
      if (this.searchPayload.tgaCardStatus)
        params.append("tgaCardStatus", this.searchPayload.tgaCardStatus);
      if (this.searchPayload.nationality)
        params.append("nationality", this.searchPayload.nationality);
      if (
        this.searchPayload.licenseType &&
        this.searchPayload.licenseType.length
      )
        params.append(
          "licenseType",
          this.searchPayload.licenseType?.map((each) => each.value)
        );
      if (
        !this.searchPayload.selected_radio_provider &&
        this.searchPayload.provider
      )
        params.append("provider", this.searchPayload.provider);
      if (this.searchPayload.selected_radio_provider)
        params.append("provider", this.searchPayload.selected_radio_provider);

      if (this.searchPayload.licenseExpiry)
        params.append(
          "licenseExpiry",
          "gt:" + this.searchPayload.licenseExpiry
        );

      if (this.searchPayload.driver_license_end_date) {
        const date = new Date(this.searchPayload.driver_license_end_date);
        date.setHours(24);
        date.setMinutes(59);
        params.append(
          "licenseExpiry",
          "lte:" + this.searchPayload.driver_license_end_date + "T23:59:59.000Z"
        );
      }

      if (this.searchPayload.name)
        params.append("name", "*" + this.searchPayload.name + "*");

      if (this.searchPayload.arabicName)
        params.append("arabicName", "*" + this.searchPayload.arabicName + "*");

      if (this.searchPayload.mobileNumber)
        params.append(
          "mobileNumber",
          "*" + this.searchPayload.mobileNumber + "*"
        );

      if (this.$store.getters["enums/user_info"].clientID) {
        params.append(
          "reservedClients",
          "in:" + [this.$store.getters["enums/user_info"].clientID]
        );
        const statusArray = ["available", "lta booked"];
        params.append("status ", "in:" + statusArray);
      }

      if (this.searchPayload.employee_id)
        params.append("employeeID", "*" + this.searchPayload.employee_id + "*");

      if (this.searchPayload.idNumber)
        params.append("idNumber", "*" + this.searchPayload.idNumber + "*");
      if (this.showDownloadFilters ) {
        this.download(params)
        this.$emit("resetSearch");
      }
      params.append(
        "select",
        "employeeID,_id,provider.name,provider.arabicName,name,arabicName,mobileNumber,rating,status,garage.name,garage.arabicName,vehicle.make.name,vehicle.make.arabicName,active"
      );
  
      try {
        const response = await DriverService.search(params);
        const data = response.items?.map((each, index) => {
          return {
            employeeID: each?.employeeID,
            driverId: each?._id,
            provider: this.isLangRtl
              ? each?.provider?.arabicName || ""
              : each?.provider?.name || "",
            assigned_vehicle: this.isLangRtl
              ? each?.vehicle?.make?.arabicName || ""
              : each?.vehicle?.make?.name || "",
            name: each?.name,
            arabicName: each?.arabicName,
            mobileNumber: each?.mobileNumber || "---",
            active: each?.active,
            rating: each?.rating,
            status: each?.status,
            garage: this.isLangRtl
              ? each?.garage?.arabicName || ""
              : each?.garage?.name || "",
          };
        });

        this.items = data;
        this.rows = response.total;
        this.loading = false;
        const availableLengths = response?.available;
        this.availableLengths = availableLengths;
        const totalDrivers = response?.total;

        this.$emit(
          "getAvailableLengths",
          this.availableLengths,
          this.unAvailableLengths,
          totalDrivers
        );
      } catch (error) {
        this.error = error.message;
        this.items = [];
        this.rows = 0;
        this.loading = false;
      }

      if (!this.searchPayload.availability_date) {
        const thisDay = new Date();
        this.searchPayload.availability_date = thisDay
          .toISOString()
          .substring(0, 10);
      }
    },
    // driversAvailability() {
    //   this.loading = true;
    //   this.error = null;

    //   let payload = { unassignedVehicles: true };
    //   if (this.searchPayload?.availability_date)
    //     payload["date"] = this.searchPayload.availability_date;

    //   DriverService.driversAvailability(payload)
    //     .then((response) => {
    //       const availableLengths = response?.availableDrivers;
    //       this.availableLengths = availableLengths;
    //       const totalDrivers = response?.totalDrivers;

    //       this.$emit(
    //         "getAvailableLengths",
    //         this.availableLengths,
    //         this.unAvailableLengths,
    //         totalDrivers
    //       );
    //     })
    //     .catch(({ message }) => {
    //       this.error = message;
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    resetSearchPayload() {
      this.searchPayload.provider = "";
      this.searchPayload.gender = "";
      this.searchPayload.status = [];
      this.searchPayload.religion = "";
      this.searchPayload.serviceType = "";
      this.searchPayload.tgaCardStatus = "";
      this.searchPayload.designationType = "";
      this.searchPayload.nationality = null;
      this.selectedNationality = null;
      this.selected = "saptco";
      this.searchPayload.licenseType = [];
      this.searchPayload.driver_license_end_date = null;
      this.searchPayload.licenseExpiry = null;
      this.searchPayload.id = "";
      this.searchPayload.employee_id = "";
      this.searchPayload.idNumber = "";
      this.searchPayload.selected_radio_provider = "";
      this.searchPayload.name = "";
      this.searchPayload.arabicName = "";
      this.searchPayload.mobileNumber = "";
      this.searchPayload.availability_date = null;
      this.searchPayload.garage = [];
      this.$emit("resetQuickSearchPayload");
      this.filterBySideBar();
    },
    routeToDetails(item) {
      if (!this.$store.getters["enums/is_not_permitted"]("editDriver"))
        this.$router.push(`/driver/${item?.driverId}`).catch(() => {});
    },
    changeParentSorting(sortBy, sortDesc) {
      this.sortByProp = sortBy;
      this.sortDescProp = sortDesc;
    },
    groupByKey(key) {
      this.group_by_key = key;
      this.group_by_data =
        key === "none" ? null : this.groupBy(this.items, key);
    },
    quickSearch(key, value) {
      this.quick_search_key = key;
      this.quick_search_value = value;
      this.filterBySideBar();
    },
    download(params) {
      this.loading = true;
      this.error = null;
      DriverService.download(params)
        .then((res) => {
          this.$store.dispatch("enums/SHOW_TOASTER_POP", {
              message: this.$t("export-processed-msg"),
              variant: "success",
              title: this.$t("success"),
              duration: 5000,
              noCloseButton: false,
            });
          this.downloadFile(
            res,
            `drivers-${moment()
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY")}.xlsx`
          );

        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.filterBySideBar();
  },
  created() {
    this.$store.dispatch("enums/GET_PROVIDER_ENUMS", { forceFetch: true });
    this.$store.dispatch("enums/GET_LICENSE_TYPE_ENUMS");
    this.$store.dispatch("enums/GET_NATIONALITY_ENUMS");
    this.$store.dispatch("enums/GET_GARAGE_ENUMS");
    this.$store.dispatch("enums/GET_RELIGION_ENUMS");
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/vehicles.json"),
      ar: require("@/services/i18n/locales/ar/vehicles.json"),
    },
  },
};
</script>

<style lang="scss">
.assigned_vehicle {
  min-width: 100px;
}
.grid-block {
  .topbar {
    border-radius: 0.5rem 0.5rem 0rem 0rem;
    background: var(--color-84);
    display: flex;
    padding: 0.4375rem 1rem;
    justify-content: space-between;
    align-items: center;
    color: var(--color-61);
    font-size: 0.75rem;
    .name {
      font-size: 0.875rem;
      font-weight: 700;
    }
  }
  .content {
    height: 160px;
    padding: 1rem 1rem 0.5rem 1rem;
    border-radius: 0rem 0rem 0.25rem 0.25rem;
    border: 1px solid var(--color-84);
    background: var(--color-01);
    .field {
      color: var(--color-109);
      font-size: 0.75rem;
    }
    .value {
      color: var(--color-61);
      font-size: 0.875rem;
      font-weight: 700;
    }
  }
}
</style>
